import VueRouter from 'vue-router';
import Vue, {Component} from 'vue';
import HomeView from "@/views/HomeView.vue";
import CreateArticleView from "@/views/CreateArticleView.vue";
import ArticleView from "@/views/ArticleView.vue";
import AccountView from "@/views/AccountView.vue";
import ArticleCrossroadView from "@/views/ArticleCrossroadView.vue";
import SeoScoreDetailView from "@/views/SeoScoreDetailView.vue";
import NavrhVyberView from '@/views/NavrhVyberView.vue';
import KeywordLucyRowSmokeView from '@/views/KeywordLucyRowSmokeView.vue';
import UrlImproveLucySmokeView from '@/views/UrlImproveLucySmokeView.vue';
import RewriteSectionsSmokeView from '@/views/RewriteSectionsSmokeView.vue';
import firebaseConfig from 'firebaseConfig';
import {Environment} from '@/utils/Environment';

Vue.use(VueRouter);

// route level code-splitting
// this generates a separate chunk ([name].[hash].js) for this route
// which is lazy-loaded when the route is visited.
// const getView = (name: string) => () => import(`@/views/${name}.vue`) as Component;

interface Route {
    path: string,
    name: string,
    component: Component,
    props?: object
}

/** `.firebaserc` projects.production. Only the production build carries its config. */
export const PRODUCTION_PROJECT_ID = 'seowritee-com';

/**
 * Smoke fixtures and the /navrh-vyber design board are not for users. They are
 * registered everywhere except production hosting, where the catch-all sends
 * them to Home. NODE_ENV cannot tell production apart: DEV hosting and CI build
 * in production mode too. CI smoke (ci/rewrite-sections-smoke.mjs) serves the
 * built bundle on 127.0.0.1, so a loopback host keeps them whatever config it has.
 */
function internalRoutesEnabled(): boolean {
    return firebaseConfig.projectId !== PRODUCTION_PROJECT_ID || Environment.isLocalPreviewHost();
}

const internalRoutes: Array<Route> = [
    {
        path: '/navrh-vyber',
        name: 'NavrhVyber',
        component: NavrhVyberView,
    }, {
        path: '/keyword-lucy-smoke',
        name: 'KeywordLucyRowSmoke',
        component: KeywordLucyRowSmokeView,
    }, {
        path: '/url-improve-lucy-smoke',
        name: 'UrlImproveLucySmoke',
        component: UrlImproveLucySmokeView,
    }, {
        path: '/rewrite-sections-smoke',
        name: 'RewriteSectionsSmoke',
        component: RewriteSectionsSmokeView,
    }
];

const routes: Array<Route> = [
    {
        path: '/',
        name: 'Home',
        component: HomeView
    }, {
        path: '/account',
        name: 'Account',
        component: AccountView
    }, {
        path: '/createArticle',
        name: 'CreateArticle',
        component: CreateArticleView
    }, {
        path: '/article/:articleId',
        name: 'Article',
        component: ArticleView
    }, {
        path: '/s/:token',
        name: 'SharedArticle',
        component: ArticleView
    }, {
        path: '/analyzeArticle',
        name: 'AnalyzeArticle',
        component: CreateArticleView,
        props: { isAnalyze: true }
    }, {
        path: '/articleCrossroad',
        name: 'ArticleCrossroadView',
        component: ArticleCrossroadView,
    }, {
        path: '/seo-skore',
        name: 'SeoScoreDetail',
        component: SeoScoreDetailView,
    },
    ...(internalRoutesEnabled() ? internalRoutes : []),
    {
        path: '/:pathMatch(.*)*',
        //@ts-ignore
        redirect: { name: 'Home' }
    }
];

// Enable for route-level code-split
// for (const route of routes) {
//     route.component = getView(route.name);
// }

const Router = new VueRouter({
    mode: 'history',
    routes
});

export {Router};
